<template>
	<div class="flex flex-col">
		<div class="mgs-hole-edit flex items-center">
			<div>Shot Type</div>
			<select
				class="mgs-scorecard-input"
				v-model="shot.shot_type"
				@change="$emit('update-score', roundHole)"
			>
				<option
					:value="metaType.id"
					:key="`shot-type-${metaType.id}-${roundHole.hole}-${shot.shot_number}`"
					v-for="metaType of shotTypes"
				>
					{{ metaType.title }}
				</option>
			</select>
		</div>

		<div
			class="mgs-hole-edit flex items-center"
			v-if="shot.shot_type === 1 && roundHole.par > 3"
		>
			<div>Fairway</div>
			<course-fairway-select :course-hole="roundHole"></course-fairway-select>
		</div>
		<div
			v-if="
				!roundHole.gir &&
					roundHole.score &&
					roundHole.par - shot.shot_number === 1 &&
					shot.shot_type != 6 &&
					shot.shot_type != ''
			"
			class="mgs-hole-edit flex items-center"
		>
			<div>Scramble Method</div>
			<course-scramble-select :course-hole="roundHole"></course-scramble-select>
		</div>
		<div class="mgs-hole-edit flex items-center">
			<div class="">Remaining Distance to hole</div>
			<input
				class="mgs-scorecard-input ml-2"
				type="number"
				min="0"
				v-model="shot.distance_remaining_to_hole"
			/>
			<select
				class="mgs-scorecard-input"
				v-model="shot.distance_unit"
				@change="$emit('update-score', roundHole)"
			>
				<option
					:value="metaDistanceUnit.id"
					:key="
						`distance-type-${metaDistanceUnit.id}-${roundHole.hole}-${shot.shot_number}`
					"
					v-for="metaDistanceUnit of filteredDistanceUnits"
				>
					{{ metaDistanceUnit.title }}
				</option>
			</select>
		</div>
		<div
			class="mgs-hole-edit flex items-center justfiy-end"
			v-if="shot.shot_type === 6 && shot.distance_remaining_to_hole === ''"
		>
			<button class="ml-auto" @click="holeOut">Hole Out</button>
		</div>
		<!-- <div class="mgs-hole-edit flex items-center">
			<div class="flex-grow">&nbsp;</div>
			<button class="button mgs-button is-small" @click="saveShot">SAVE SHOT</button>
		</div> -->
	</div>
</template>
<script>
/** @format */
import ApiService from "../../services/ApiService";
import holeMod from "./../../modules/hole";

export default {
	name: "HoleShotForm",
	props: {
		golfRound: {
			type: Object,
			required: true
		},
		roundHole: {
			type: Object,
			required: true
		},
		shotMeta: {
			type: Object,
			required: true
		},
		shot: {
			type: Object,
			required: true
		},
		previousShot: {}
	},
	components: {
		"course-fairway-select": () =>
			import(/* webpackChunkName: "CourseFairwaySelect" */ "./../Course/FairwaySelect"),
		"course-scramble-select": () =>
			import(/* webpackChunkName: "CourseScrambleSelect" */ "./../Course/ScrambleSelect")
	},
	created() {
		const type = this.shot.shot_type;
		this.setDistanceUnitFromType(type);
	},
	methods: {
		holeOut() {
			this.shot.distance_remaining_to_hole = 0;
			this.shot.distance_unit = 2;

			this.$emit("save-round", this.roundHole);
		},
		setDistanceUnitFromType(type) {
			if (this.shot.distance_unit == undefined || this.shot.distance_unit === "") {
				if ([1, 4].find(i => i === type)) {
					this.shot.distance_unit = 1;
				} else if ([2, 3, 5, 6].find(i => i === type)) {
					this.shot.distance_unit = 2;
				}
			}
		}
	},
	computed: {
		shotTypesLength() {
			return this.shotTypes.length;
		},
		scoreClasses() {
			return holeMod.scoreClasses(this.roundHole);
		},
		payload() {
			return {
				hole_uuid: this.roundHole.uuid,
				// 'user_uuid': '',
				distance_remaining_to_hole: this.shot.distance_remaining_to_hole,
				distance_unit: this.shot.distance_unit,
				shot_number: this.shot.shot_number,
				shot_type: this.shot.shot_type
			};
		},
		shotTypes() {
			return this.shotMeta.types.filter(type => {
				if (type.id === 1) {
					if (this.roundHole.par !== 3 && this.shot.shot_number === 1) return true;
				} else if (type.id === 2) {
					if (this.roundHole.par === 3 && this.shot.shot_number === 1) return true;
				} else if ((type.id > 2 && type.id <= 4) || type.id === 6 || type.id === 7) {
					if (this.shot.shot_number > 1) return true;
				} else if (type.id === 5) {
					return false;
				} else {
					return false;
				}
			});
		},
		filteredDistanceUnits() {
			return this.shotMeta.distanceUnits.filter(unit => {
				// if (unit.id === 1) {
				// 	if (this.shot.shot_type !== 5) return true;
				// } else {
				// 	if (this.shot.shot_type === 5) return true;
				// }
				return true;
			});
		}
	},
	watch: {
		shotTypesLength: {
			immediate: true,
			handler(l) {
				if (!this.shot.shot_type) {
					if (this.shot.shot_number > this.roundHole.par - 2) {
						if (this.previousShot != undefined) {
							if (this.previousShot.distance_unit === 2) {
								const puttType = this.shotTypes.find(t => t.id === 6);
								if (puttType != undefined) {
									this.shot.shot_type = puttType.id;
								}
							} else {
								this.shot.shot_type = this.shotTypes[0].id;
							}
						}
					} else {
						this.shot.shot_type = this.shotTypes[0].id;
					}
				}
			}
		},
		"shot.shot_type"(type) {
			this.setDistanceUnitFromType(type);
		}
	}
};
</script>
<style lang="scss"></style>
